<template>
  <div @click="copyAction" class="btn"
  >
    <img class="img-icon" src="../../../assets/invoice/ic_copy.png" alt="" />
  </div>
</template>
<script>
export default {
  name: "copy-btn",
  props: {
    text: {
      type: String,
      default: ''
    }
  },
  methods: {
    copySuccess(val) {
      console.log('in copySuccess ', val);
    },
    copyError(val) {
      console.log('in copyError ', val);
    },
    async copyAction() {
      try {
        const textToCopy = this.text;
        console.log('const textToCopy = ', textToCopy);
        await navigator.clipboard.writeText(textToCopy);
        console.log("文本已复制到剪贴板");
        this.$toast({message: '复制成功'});
      } catch (err) {
        console.error("复制到剪贴板失败", err);
      }
    }
  }
}
</script>


<style scoped lang="scss">
.btn {
  width: 32px;
  height: 32px;
}
.img-icon {
  width: 32px;
  height: 32px;
}
</style>
